import { registerPlugin, Plugin } from '@capacitor/core';
import { WebPlugin } from '@capacitor/core';

export interface PedoListenerPlugin {
  echo(options: { value: string }): Promise<{ value: string }>;
  pedoCommand(options: { cmd: string }): Promise<{ response: string }>;
}

class PedoListenerWeb extends WebPlugin implements PedoListenerPlugin {
  async echo(options: { value: string }): Promise<{ value: string }> {
    // console.log('ECHO', options.value);
    return options;
  }
  async pedoCommand(options: { cmd: string }): Promise<{ response: string }> {
    // console.log('cmd: ' + options.cmd)
    return {response: 'Not supported in web'}
  }
}

interface PedoListenerNative extends Plugin {
  echo: (options: { value: string }) => Promise<{value: string}>
  pedoCommand: (options: { cmd: string }) => Promise<{response: string}>
}

export const PedoListener = registerPlugin<PedoListenerPlugin>('PedoListener', {
  web: () => new PedoListenerWeb()
});

export const PedoListenerApp = registerPlugin<PedoListenerNative>('PedoListenerPlugin');


